"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  unknownCadastralCode: 'кадастровый номер неизвестен',
  goToPayment: 'перейти к оплате',
  addedCadastralCode: 'Добавлен кадастровый номер'
};